import React from 'react';
import PropTypes from 'prop-types';

// Styles
import styles from './CheckboxList.module.scss';

// Components
import Checkbox from '../Checkbox';

const CheckboxList = ({ items, onChangeCheckbox  }) => (
    <ul className={styles.checkboxList}>
        {items.map(({ value, label, isChecked }, itemIndex) => (
            <li key={itemIndex}>
                <div className={styles.checkboxContainer}>
                    <Checkbox
                        id={`${value}${itemIndex}`}
                        isChecked={isChecked}
                        onChange={({ target: { checked: isChecked } }) => onChangeCheckbox(value, isChecked)}
                    />
                </div>
                <label htmlFor={`${value}${itemIndex}`}>
                    {label}
                </label>
            </li>
        ))}
    </ul>
);

CheckboxList.propTypes = {
    items: PropTypes.arrayOf(PropTypes.exact({
        value: PropTypes.string,
        label: PropTypes.string,
        isChecked: PropTypes.bool
    })).isRequired,
    onChangeCheckbox: PropTypes.func.isRequired,
};

export default CheckboxList;